module.exports = __webpack_public_path__ + "img/struggle.9342277c.png";